module.exports = __webpack_public_path__ + "img/nitro.1835fe58.png";